<script>
export default {
    props: ["items", "initialName"],

    data() {
        return {
            name: this.initialName,
            current: 0,
        };
    },

    computed: {
        filterItems() {
            name = this.name;

            return this.items.filter(function (item) {
                return name.indexOf(item.name) >= 0;
            });
        },
    },
};
</script>
